
import React from 'react'
import Layout from "../components/utils/layout";
import Filters from "./filters";
import NamedQueryModule from "../components/data_modules/named_query_module";
import Formatters from "../components/utils/formatters";

const Affiliates = () => {
    const screenId="Affiliates"
    const charts = {
        referral_usage : {
            source:"live"
        },
        orders_by_source : {
            source:"live"
        },
        orders_by_source_mse : {
            source:"live"
        },
        orders_by_source_finder : {
            source:"live"
        },
        orders_by_source_times : {
            source:"live"
        },
        orders_by_source_guardian : {
            source:"live"
        }
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default Affiliates